/**
 * Given an array and a comparison function, finds the member that would be at the start of the list
 * if this comparison function were used to sort
 */
export default (array, compare) => array.reduce(
  (result, next) => result == null || compare(result, next) > 0 ? next : result,
  null,
)
